<template>
  <div class="padding">
    <button v-if="copyButton" class="btn btn-primary mb-3" @click="$emit('copy')">
      Gebruik hetzelfde adres van verzending
    </button>

    <div class="d-flex">
      <FormInput
        v-model="$v.firstName.$model"

        class="sm form-element"
        :disabled="disabled"
        :ske="true"
        :vuelidate="$v"
        :focus="true"
        fieldName="firstName"

        id="firstName"
        label="Voornaam"
      />
      <FormInput
        v-model="$v.lastName.$model"

        class="sm form-element"
        :disabled="disabled"
        :ske="true"
        :vuelidate="$v"
        fieldName="lastName"

        id="lastName"
        label="Achternaam"
      />
    </div>
    <FormInput
      v-model="$v.email.$model"

      :disabled="disabled"
      :ske="true"
      :vuelidate="$v"
      fieldName="email"
      type="email"

      id="email"
      label="Email"
    />
    <div class="d-flex">
      <FormInput
        v-model="$v.street.$model"

        class="sm form-element"
        :disabled="disabled"
        :ske="true"
        :vuelidate="$v"
        fieldName="street"

        id="street"
        label="Straat"
      />
      <FormSelect class="sm form-element"
        v-model="$v.countryCode.$model"
        :ske="true"
        :options="countryCodeOptions"

        id="size"
        label="Landcode"
      />
    </div>
    <div class="d-flex">
      <FormInput
        v-model="$v.houseNumber.$model"

        class="sm form-element"
        :disabled="disabled"
        :ske="true"
        :vuelidate="$v"
        fieldName="houseNumber"

        id="houseNumber"
        label="Huisnummer"
      />
      <FormInput
        v-model="$v.houseNumberExtension.$model"

        class="sm middle form-element"
        :disabled="disabled"
        :ske="true"
        :vuelidate="$v"
        fieldName="houseNumberExtension"

        id="houseNumberExtension"
        label="Huisnummer Toevoeging"
      />
      <FormInput
        v-model="$v.telephone.$model"

        class="sm form-element"
        :disabled="disabled"
        :ske="true"
        :vuelidate="$v"
        fieldName="telephone"

        id="telephone"
        label="Telefoon"
      />
    </div>
    <div class="d-flex">
      <FormInput
        v-model="$v.city.$model"

        class="sm form-element"
        :disabled="disabled"
        :ske="true"
        :vuelidate="$v"
        fieldName="city"

        id="city"
        label="Stad"
      />
      <FormInput
        v-model="$v.postalCode.$model"

        class="sm form-element"
        :disabled="disabled"
        :ske="true"
        :vuelidate="$v"
        fieldName="postalCode"

        id="postalCode"
        label="Postcode"
      />
    </div>

    <div class="d-flex">
      <FormInput
        v-model="$v.companyName.$model"

        class="sm form-element"
        :disabled="disabled"
        :ske="true"
        :vuelidate="$v"
        fieldName="companyName"

        id="companyName"
        label="Bedrijfsnaam"
      />
      <FormInput
        v-model="$v.shopName.$model"

        class="sm form-element"
        :disabled="disabled"
        :ske="true"
        :vuelidate="$v"
        fieldName="shopName"

        id="shopName"
        label="Winkelnaam"
      />
    </div>
    <div class="d-flex">
      <FormInput
        v-model="$v.iban.$model"

        class="sm form-element"
        :disabled="disabled"
        :ske="true"
        :vuelidate="$v"
        fieldName="iban"

        id="iban"
        label="Iban"
      />
      <FormInput
        v-model="$v.vatId.$model"

        class="sm form-element"
        :disabled="disabled"
        :ske="true"
        :vuelidate="$v"
        fieldName="vatId"

        id="vatId"
        label="BTW-nr"
      />
    </div>
  </div>
</template>

<script>

import FormInput from "../../components/Inputs/FormInput.vue"
import FormSelect from "../../components/Inputs/FormSelect.vue"

import setupForm from "../../mixins/setupForm"
import { required, email } from "vuelidate/lib/validators"

const fields = ["firstName", "lastName", "email", "street", "countryCode", "houseNumber", "houseNumberExtension", "telephone", "city", "postalCode", "vatId", "iban", "companyName", "shopName"]
const requiredFields = ["firstName", "lastName", "email", "street", "countryCode", "houseNumber", "city", "postalCode"]

export default setupForm(
  fields, {
  components: {
    FormInput,
    FormSelect,
  },
  props: {
    copyButton: Boolean,
    disabled: Boolean,
    wholesale: Boolean,
  },
  validations() {
    if (this.wholesale) {
      return {
        ...requiredFields.reduce((obj, key) => ({
          ...obj,
          [key]: { },
        }), {}),

        email: {
          email,
        },
        houseNumber: {},
      }
    }
    return {
      ...requiredFields.reduce((obj, key) => ({
        ...obj,
        [key]: { required },
      }), {}),

      email: {
        required,
        email,
      },
      houseNumber: {},
    }
  },
  data() {
    return {
      countryCode: 'NL',
    }
  },
  computed: {
    countryCodeOptions() {
      return [
        {
          value: "NL",
          str: "NL",
        },
        {
          value: "BE",
          str: "BE",
        },
        {
          value: "DE",
          str: "DE",
        },
        {
          value: "FR",
          str: "FR",
        },
      ]
    },
  },
})

</script>

<style scoped src="@/assets/css/form.css"></style>
